import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { GuardianScreen } from "../../screens/settings-money/index.ts";

const PARTS = ["rules", "approvals", "data"] as const;
type Part = (typeof PARTS)[number];

/**
 * `/settings/guardian`: rules, protection and what waits for an administrator (see `GuardianScreen`). The part that
 * shows is `?tab=rules|approvals|data` (the overview has no parameter); the mail's link opens `?approval=<id>`.
 */
export const Route = createFileRoute("/_app/settings/guardian")({
  validateSearch: (search: Record<string, unknown>): { approval?: string; tab?: Part } => ({
    ...(typeof search.approval === "string" && /^[0-9a-f-]{36}$/i.test(search.approval)
      ? { approval: search.approval }
      : {}),
    ...(PARTS.includes(search.tab as Part) ? { tab: search.tab as Part } : {}),
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.prefetchQuery(actions.queryOptions("guardian.overview", {})),
      context.queryClient.prefetchQuery(actions.queryOptions("guardian.listRules", {})),
    ]),
  component: GuardianScreen,
});
